import { useCallback } from "react";
import { ColumnsWithGroupData, getColumnsWithGroup } from "../../api/Windows";
import { getCurrentPlant } from "../../util/ApiOptionsHelper";
import { useWorkOrderStore } from "../../store/wo-order";
import { useLocation } from "react-router";

export default function useGetCreateWoMetaData() {
  const setCreateWoMetaData = useWorkOrderStore(
    (state) => state.setCreateWoMetaData
  );
  const isRequester = useLocation().pathname.includes("requester");

  const getCreateWoMetaData = useCallback(async () => {
    const data: ColumnsWithGroupData = {
      WindowName: isRequester ? "mob_requester" : "mob_wo_nb_quick",
      ContextPKey: {
        Plant: await getCurrentPlant(),
        WoBase: "",
        WoTask: "  ",
        WoSubtask: "  ",
      },
      IncludeValidValues: "true",
    };
    const response = await getColumnsWithGroup(data);
    if (!response.isError) {
      setCreateWoMetaData(response.data);
    }
    return response;
  }, [isRequester, setCreateWoMetaData]);

  return { getCreateWoMetaData };
}
